import React, { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { get } from 'lodash/fp';
import { Redirect } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { userLogoutAction } from 'store/actions/login';
import { views } from 'enums/menu-enums';
import useUser from 'hooks/useUser';
import { FONTS } from 'styles/theme/fonts';
import { COLORS } from 'styles/theme/colors';
import SideMenuItem from 'components/common/MenuItem';

export const SideBar = ({ view }) => {
  const dispatch = useDispatch();
  const openOrdersCount = useSelector((state) =>
    state.openOrders.all ? get('openOrders.all.metadata.totalCount')(state) : 0,
  );
  const { user } = useUser();
  const [isLoggedOut, setIsLoggedOut] = useState(false);
  const username = get('username')(user) || '';
  const handleLogout = () => {
    dispatch(userLogoutAction());
    setIsLoggedOut(true);
  };

  return (
    <SideBar.SideBar>
      <SideBar.NameContainer>
        <SideBar.UserName title={username}>{username}</SideBar.UserName>
      </SideBar.NameContainer>
      <SideBar.Inventory> INVENTORY </SideBar.Inventory>
      <SideBar.MenuContainer>
        <SideMenuItem
          title={views.activeListings}
          destination="/inventory"
          active={view === 'Active Listings'}
        />
        <SideBar.Orders>ORDERS</SideBar.Orders>
        <SideMenuItem
          title={views.open}
          destination="/orders/open"
          active={view === 'Open'}
          count={openOrdersCount}
          showCount
        />
        <SideMenuItem
          title={views.completed}
          destination="/orders/completed"
          active={view === 'Completed'}
        />
      </SideBar.MenuContainer>
      <SideBar.Logout onClick={handleLogout}>logout </SideBar.Logout>
      {isLoggedOut && <Redirect to="/login" />}
    </SideBar.SideBar>
  );
};

SideBar.SideBar = styled.aside`
  width: 218px;
  height: 100%;
  background-color: ${COLORS.primaryBackground};
  border-right: 1px solid ${COLORS.primaryBorder};
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
`;

SideBar.Logout = styled.button`
  background: none;
  border: none;
  border-bottom: 1px solid ${COLORS.primarySideBarBorder};
  padding: 3px 0px;
  border-bottom: 1px solid ${COLORS.primarySideBarBorder};
  position: fixed;
  bottom: 28.5px;
  cursor: pointer;
  left: 32px;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  font-family: ${FONTS.default};
  margin-top: 24px;
  color: ${COLORS.primaryText};
  text-transform: capitalize;

  &:focus {
    outline: none;
  }
`;

SideBar.NameContainer = styled.div`
  margin-top: 56px;
  display:flex;
  width: 100%
  justify-content: flex-start;
  padding-left: 28px;
`;

SideBar.UserName = styled.h1`
  margin-top: 56px;
  color: ${COLORS.primaryText};
  font-family: ${FONTS.special};
  font-size: 24px;
  line-height: 25px;
  letter-spacing: 2px;
  text-align: left;
  margin-bottom: 0;
  max-width: 170px;
  text-overflow: ellipsis;
  overflow: hidden;
`;

SideBar.Inventory = styled.span`
  height: 14px;
  color: ${COLORS.secondaryText};
  font-family: ${FONTS.emphasized};
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 3px;
  margin-top: 79px;
  display: block;
  text-align: left;
  width: 100%;
  padding: 12px 0px 12px 32px;
`;

SideBar.Orders = styled.span`
  height: 14px;
  width: 83px;
  color: ${COLORS.secondaryText};
  font-family: ${FONTS.emphasized};
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 3px;
  margin-top: 48px;
  margin-bottom: 28px;
  padding: 12px 0px 12px 32px;
  display: block;
  text-align: left;
`;

SideBar.MenuContainer = styled.span`
  margin-top: 28px;
  width: 100%;
`;

SideBar.propTypes = {
  view: PropTypes.string,
};

export default SideBar;
